import React from 'react'

import { filterMissing } from '../util/objects.js'

export default function DescriptionList ({ items = {}, className, inline, hideEmpty }) {
  if (hideEmpty) items = filterMissing(items)
  const labels = Object.keys(items)
  let style = className === undefined ? 'ncss-dl' : className
  if (inline) {
    style = style.replace(/ncss-dl\s?$/, '')
    style += ' ncss-dl-inline'
  }

  let definitions = labels.reduce((list, label, i) => {
    list.push(<dt key={`${label}-${i}-dt`}>{label}</dt>)
    list.push(<dd key={`${label}-${i}-dd`}>{items[label]}</dd>)
    return list
  }, [])

  return <dl className={style}>
    {definitions}
  </dl>
}



// WEBPACK FOOTER //
// ./client/src/components/DescriptionList.js